export default "__VITE_PUBLIC_ASSET__7db71f59__"